import { LatLng } from '../interfaces';

export const INVISIBLES = /[\u200B-\u200D\uFEFF\u200E\u200F\u202A-\u202E\u2060-\u2064\u206A-\u206F]/g;
export const stripInvisibles = (value?: string | null): string =>
  typeof value === 'string' ? value.replace(INVISIBLES, '') : '';
export const VIMEO_REPLACE_PATTERN = /vimeo\.com\/(\d+)/;
export const VIMEO_EMBED_TEMPLATE = 'player.vimeo.com/video/$1';

export const itemsPerPageOptions = [
  { label: '12', value: 12 },
  { label: '25', value: 25 },
  { label: '50', value: 50 },
  { label: '100', value: 100 },
];

export const ITEM_ALIGNMENT = {
  left: 'left',
  center: 'center',
  right: 'right',
};

//Logo Wall
export const LOGO_SIZE = { width: 214, height: 110 } as const;
export const COMPONENT_POSITION = {
  POSITION_LEFT: 'left',
  POSITION_RIGHT: 'right',
  POSITION_CENTER: 'center',
};

export const INTERVAL_TIME = 5000; //5s

// Hard default: 483 George St, Sydney NSW 2000
export const SYD_TOWN_HALL: LatLng = { lat: -33.8732, lng: 151.2065 };

export const BUTTON_VARIANTS = ['primary', 'secondary', 'tertiary', 'text'] as const;

export const SANITY_TYPE = {
  GENERIC_PAGE: 'genericPage',
  STRUCTA_PRODUCT_LEVEL1: 'structaProductLevel1',
  STRUCTA_PRODUCT_LEVEL2: 'structaProductLevel2',
  STRUCTA_PRODUCT_LEVEL3: 'structaProductLevel3',
  PRODUCTS_LIST: 'productsList',
  PRODUCT: 'product',
  ARTICLE: 'article',
  DOCUMENT_PAGE: 'documentPage',
};
